import { render, staticRenderFns } from "./about-edit.vue?vue&type=template&id=51ae204d&scoped=true&"
import script from "./about-edit.vue?vue&type=script&lang=js&"
export * from "./about-edit.vue?vue&type=script&lang=js&"
import style0 from "./about-edit.vue?vue&type=style&index=0&id=51ae204d&prod&lang=scss&"
import style1 from "./about-edit.vue?vue&type=style&index=1&id=51ae204d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae204d",
  null
  
)

export default component.exports